import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function WagesWorker() {
  const dispatch = useDispatch();
  /*   ALL STATES
   ********************************************* */

  const [workerList, setWorkerList] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [departmentList, setDepartmentList] = useState([]);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  //get Data
  const getWorkerList = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/manufacturer/wages/workers", {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerList(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const getDepartmentList = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/manufacturer/wages/departments", {
        headers: authHeader(),
      });
      if (data?.success) {
        setDepartmentList(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete Quotations
  const deleteWorker = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/manufacturer/wages/worker/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerList((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const AddWorker = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/manufacturer/wages/worker", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerList((prev) => [...prev, data?.data]);
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const UpdateWorker = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer/wages/worker/",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setWorkerList((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getWorkerList();
      getDepartmentList();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary  ms-1"
        >
          Add Worker
        </button>
      </>
    </div>
  );

  const table_head = [
    "ID",
    "Worker Name",
    "Department",
    "CNIC",
    "Status",
    "Actions",
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="align-middle py-1">{item.workerId}</td>
      <td className="align-middle py-1">{item.workerName}</td>
      <td className="align-middle py-1">
        {departmentList.find((dept) => dept.id === item.departmentId)
          ?.departmentName || "N/A"}
      </td>
      <td className="align-middle py-1">{item.cnic || "N/A"}</td>
      <td className="align-middle py-1">
        {item.isArchived ? (
          <span className="badge fs-6 py-1 px-2 bg-secondary">Archived</span>
        ) : (
          <span className="badge fs-6 py-1 px-2 bg-success">Active</span>
        )}
      </td>
      <td className="align-middle py-1">
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn py-0 px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn  py-0 px-1"}
          deleteFunc={deleteWorker}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="">
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="px-2 flex-grow-1 d-flex"
        style={{ height: "79vh", overflowY: "auto" }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            btn1={btn1}
            table_head={table_head}
            table_body={table_body}
            table_data={workerList}
          />
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Update Worker" : "Add Worker"}</h4>
          </div>
          <hr className="mt-0" />
          <form onSubmit={isUpdateMode ? UpdateWorker : AddWorker} className="">
            <div className="mb-2">
              <label className="">Department</label>
              <div className="">
                <select
                  value={formData?.departmentId || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      departmentId: parseInt(e.target.value),
                    });
                  }}
                  className="form-control"
                  required
                >
                  <option value="">Select Department</option>
                  {departmentList.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.departmentName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-2">
              <label className="">Worker Name</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.workerName || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      workerName: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter worker Name"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="">CNIC</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.cnic || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      cnic: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter CNIC"
                />
              </div>
            </div>

            <div className="mb-2">
              <div className="form-check">
                <input
                  type="checkbox"
                  id="isArchived"
                  checked={formData?.isArchived || false}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      isArchived: e.target.checked,
                    });
                  }}
                  className="form-check-input"
                />
                <label className="form-check-label" htmlFor="isArchived">
                  Archive Worker
                </label>
              </div>
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
